import React, { useContext, useEffect, useState } from "react";
import closeSvg from "../../../../../assets/closeSvg";
import "./TransferClientModal.css";
import { TransferClientContext } from "./TransferClientContext";
import { AppContext } from "../../../../../AppContext";
import { useNavigate } from "react-router-dom";
import { logActivity, getUserId, formatPhoneNumber } from "../../../../utils";

const TransferClientModal = ({ formId }) => {
  const {
    setUserId,
    makeKey,
    userEmail,
    userName,
    userType,
    userCompany,
    setPath,
    setClientSelection,
    userPassword,
    movePassword,
    setLoginModalInputs,
    setMatrixData,
    setLoginModalAction,
    setModal,
    setNavbar,
    setMidbar,
    setUserEmail,
    setUserCompany,
    setUserPassword,
    setUserName,
    setMakeKey,
    navigate,
    setFubId,
    setFubKey,
    setTeamMemberSelected,
    setUserPhone,
    setTextNotifications,
    setTeamMemberSelectedInfo,
    setUserCompanyId,
    setTeamPermissions,
    setBuyersGuide,
    setBuyersGuideEditable,
  } = useContext(AppContext);

  const {
    selectedClient,
    transferClientVisible,
    setTransferClientVisible,
    setStopOverflowY,
    setTransferToMoveVisible,
    successFunctions,
  } = useContext(TransferClientContext);
  const [loanOfficerList, setLoanOfficerList] = useState(<></>);

  const [loanOfficer, setLoanOfficer] = useState("unassigned");
  const [transferNote, setTransferNote] = useState("");
  const [transferNoteCount, setTransferNoteCount] = useState(0);

  const [transferSending, setTransferSending] = useState(false);

  useEffect(() => {
    fetch("/.netlify/functions/getMoveTeamList", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((body) => {
        const list = body.moveTeam
          .filter((e) => e.type == "Loan Officer")
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((e, index) => {
            return (
              <option key={index} value={`${e.name}`}>
                {e.name}
              </option>
            );
          });
        setLoanOfficerList(list);
      });
  }, []);

  const transferToMove = () => {
    const zhlInterested = selectedClient.tags.includes("ZHL Interested");
    const zhlTransferred = selectedClient.tags.includes("ZHL Transferred");
    setTransferSending(true);
    const transferToMoveUrl = `/.netlify/functions/transferToMoveUrl`;
    fetch(transferToMoveUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        fetch(data.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            apiKey: makeKey,
            userEmail: userEmail,
            userName: userName,
            userCompany: userCompany,
            loanOfficer: loanOfficer,
            clientId: selectedClient.id,
            transferNote: transferNote,
            zhlStatus: zhlTransferred
              ? "Lead has been transferred to ZHL"
              : zhlInterested
              ? "Lead is tagged as ZHL Interested but has not been transferred"
              : "Lead is not working with ZHL",
          }),
        })
          .then((response) => {
            if (!response.ok) {
              console.log(response);
              throw new Error(response);
            }
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Transferred to Move",
              tab: "Modal",
              userCompany: userCompany,
            });
            setLoanOfficer("unassigned");
            setTransferNote("");
            setTransferSending(false);
            setTransferClientVisible(false);
            setTransferToMoveVisible(false);
            alert(
              `Lead has been transferred! You can track the lead in Matrix now.`
            );
            getUserId({
              setUserId: setUserId,
              userEmail: userEmail,
              userType: userType,
              makeKey: makeKey,
              userPassword: userPassword,
              movePassword: movePassword,
              setLoginModalInputs: setLoginModalInputs,
              setMatrixData: setMatrixData,
              setLoginModalAction: setLoginModalAction,
              setModal: setModal,
              setNavbar: setNavbar,
              setMidbar: setMidbar,
              setUserEmail: setUserEmail,
              setUserPhone: setUserPhone,
              setUserCompany: setUserCompany,
              setUserCompanyId: setUserCompanyId,
              setUserPassword: setUserPassword,
              setTextNotifications: setTextNotifications,
              setUserName: setUserName,
              setMakeKey: setMakeKey,
              setPath: setPath,
              navigate: navigate,
              setClientSelection: setClientSelection,
              path: "/clients",
              clientSelection: "Pending",
              setFubId: setFubId,
              setFubKey: setFubKey,
              action: null,
              actionTab: null,
              setTeamMemberSelected: setTeamMemberSelected,
              setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
              setTeamPermissions: setTeamPermissions,
              setBuyersGuide: setBuyersGuide,
              setBuyersGuideEditable: setBuyersGuideEditable,
            });
          })
          .catch((error) => {
            console.log(error);
            alert(
              `${selectedClient.name} is already in Move database. If you do not see the client in Matrix, confirm with mike@movemortgage.com.`
            );
            setTransferSending(false);
            setTransferClientVisible(false);
            setLoanOfficer("unassigned");
            setTransferNote("");
          });
      });
  };

  // Use this to test the Transfer button UI without actually completing the transfer by commenting out the transferToMove() function and running the fakeSuccess() function.
  const fakeSuccess = () => {
    setLoanOfficer("unassigned");
    setTransferNote("");
    setTransferSending(false);
    setTransferClientVisible(false);
    setTransferToMoveVisible(false);
    setPath("/clients");
    setClientSelection("Pending");
    navigate("/clients");
    alert(`Lead has been transferred! You can track the lead in Matrix now.`);
    if (successFunctions) {
      successFunctions.map((e) => {
        e.function(e.input);
      });
    }
  };

  return (
    <div className={`ModalPage ${transferClientVisible ? "" : "hidden"} one`}>
      <div className="Modal-background stopOverflow"></div>
      <div className="Modal-container">
        {transferSending ? (
          <form className="Modal">Transferring lead...</form>
        ) : (
          <form
            id={`transferClientForm ${formId}`}
            className="Modal"
            onSubmit={(e) => {
              e.preventDefault();
              let submitTransfer = true;
              if (loanOfficer !== "unassigned") {
                const calledLo = window.confirm(
                  `Click OK to confirm that you called ${loanOfficer}`
                );
                calledLo ? (submitTransfer = true) : (submitTransfer = false);
              }
              if (loanOfficer !== "unassigned") {
                const threeWayText = window.confirm(
                  `Click OK to confirm that you sent a three way text with ${loanOfficer} and ${selectedClient.name}`
                );
                threeWayText
                  ? (submitTransfer = true)
                  : (submitTransfer = false);
              } else {
                const response = window.confirm(
                  "Confirmation: Click OK to confirm transfer."
                );
                response ? (submitTransfer = true) : (submitTransfer = false);
              }
              if (submitTransfer) {
                setTransferSending(true);
                setStopOverflowY(false);
                transferToMove();
              } else {
              }
            }}
          >
            <div className="spaceBetween">
              <b>Transfer Snapshot</b>
              <div
                className="Modal-close"
                onClick={() => {
                  setTransferClientVisible(false);
                  setStopOverflowY(false);
                }}
              >
                {closeSvg}
              </div>
            </div>
            <div className="fivePx"></div>
            <div className="detailBox">
              {!selectedClient ? null : (
                <div className="detailBoxContent">
                  <div className="spaceBetween">
                    <div>
                      {selectedClient.firstName} {selectedClient.lastName}
                    </div>
                    <div className="detailBoxStage">{selectedClient.stage}</div>
                  </div>
                  <div>
                    {selectedClient["emails"].length > 0
                      ? selectedClient["emails"][0]["value"]
                      : "No Email"}
                  </div>
                  <div>
                    {selectedClient["phones"].length > 0
                      ? formatPhoneNumber(selectedClient["phones"][0]["value"])
                      : "No Phone"}
                  </div>
                </div>
              )}
            </div>
            <div className="spaceBetween">
              Loan Officer:
              <select
                className="modal-select "
                name="loanOfficers"
                id={`loanOfficers ${formId}`}
                required
                onChange={(e) => {
                  setLoanOfficer(e.target.value);
                }}
              >
                <option value={"unassigned"}>First Available</option>
                <option disabled>-------------</option>
                {loanOfficerList}
              </select>
            </div>
            <div className="tenPx"></div>
            <div>Transfer Note:</div>
            <i className="fontSmall">
              Client's purchase goals, timeline, first-time homebuyer (?), etc.
            </i>
            <div className="fivePx"></div>
            <textarea
              className="textareaInput"
              maxLength={255}
              type="text"
              required
              onChange={(e) => {
                setTransferNote(e.target.value);
                setTransferNoteCount(e.target.value.length);
              }}
            ></textarea>
            <div className="textAlignRight">{transferNoteCount}/255</div>
            <div className="tenPx"></div>
            <button type="submit" className="button">
              Transfer
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default TransferClientModal;
